import React, { useRef, useState, useMemo, useEffect } from "react";
import DropDown from "../../../UIComponents/DropDown/DropDown";
import "../Dickies/Dickies.css";
import SearchInput from "../../../UIComponents/SearchInput/SearchInput";
import { Button } from "antd";
import SrtTable from "../Table/SrtTable";
import { useSelector, useDispatch } from "react-redux";
import {
  massSearchFilter,
  resetMassFilter,
  resetSeasonFilter,
  resetSrtData,
  selectUnselectSrtTableRows,
  srtBulkSave,
  srtExport,
  srtSeasonSearchFilter,
  resetSrtSeasonFilter,
  getSrtInitialList,
} from "../../../Redux/actions/Srt/Srt";
import Select from "../../../UIComponents/DropDown/DropDown";
import { DownloadOutlined, SyncOutlined } from "@ant-design/icons";
import { toast } from "../../../UIComponents/Toast";
import { useLocation, useNavigate } from "react-router-dom";
import { srfStyleList } from "../../../Redux/actions/Srf/Srf";
const TOTAL_PER_PAGE = 100;
const CHUNK_SIZE = 25;
const Eddie = (containerRef) => {
  const dispatch = useDispatch();
  const fileRef = useRef();
  const resetExpandRef = useRef(null);
  const hasInitialized = useRef(false);
  const [searchFilter, setSearchFilter] = useState();
  const [requestFilter, setRequestFilter] = useState();
  const [teamFilter, setTeamFilter] = useState();
  const [statusFilter, setStatusFilter] = useState();
  const [vendorFilter, setVendorFilter] = useState();
  const [colorFilter, setColorFilter] = useState();
  const [sizeFilter, setSizeFilter] = useState();
  const [seasonFilter, setSeasonFilter] = useState();
  const [singleSeason, setSingleSeason] = useState([]);
  const [singleColor, setSingleColor] = useState([]);
  const [singleSize, setSingleSize] = useState([]);
  const [singleFactory, setSingleFactory] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [seasonOptions, setSeasonOptions] = useState([]);

  const srtDataList = useSelector((state) => state?.Srt?.getSrtDataList);
  const exportArraySrt = useSelector((state) => state?.Srt?.srtExportArrayData);
  const srtRefresh = useSelector((state) => state?.Srt?.srtRefreshSpinner);
  const seasonFilterApiData = useSelector(
    (state) => state?.Srt?.seasonSearchFilterResult
  );
  const srtSeasonData = useSelector((state) => state?.Srt?.srtSeasonSearch);
  const styleListData = useSelector((state) => state?.Srf?.srfFilterData);
  const brandNameFromApi = useSelector((state) => state?.Srt?.srtBrandNames);
  const userNameMicrosoft = useSelector(
    (state) => state?.Profile?.graphCompleteData?.displayName
  );
  const selectedRowKeys = useSelector(
    (state) => state?.Srt?.srtSelectedTableRows
  );
  const srtDataForApi = JSON.parse(localStorage.getItem("DashboardData"));
  const srtDataFromDashoard = JSON.parse(localStorage.getItem("srtData"));
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const navigate = useNavigate();

  const [current, setCurrent] = useState(() => {
    const page = queryParams.get("page");
    return page ? parseInt(page) : 1;
  });

  const [pageCount, setPageCount] = useState(() => {
    const size = queryParams.get("pageSize");
    return size ? parseInt(size) : TOTAL_PER_PAGE;
  });

  useEffect(() => {
    console.log("checkingpageinsaucony", current, pageCount);
  }, [pageCount, current]);

  const updateQueryParams = (page, pageSize) => {
    const newQueryParams = new URLSearchParams(location.search);
    newQueryParams.set("page", page);
    newQueryParams.set("pageSize", pageSize);
    navigate({ search: newQueryParams.toString() }, { replace: true });
  };
  useEffect(() => {
    const page = queryParams.get("page");
    const size = queryParams.get("pageSize");

    if (page && parseInt(page) !== current) {
      setCurrent(parseInt(page));
    }

    if (size && parseInt(size) !== pageCount) {
      setPageCount(parseInt(size));
    }
  }, [location.search]);
  useEffect(() => {
    dispatch(srfStyleList("", ""));
  }, []);

  useEffect(() => {
    if (Array.isArray(styleListData)) {
      const uniqueSeasons = [
        ...new Set(
          styleListData
            .map((item) => item?.season?.trim().toUpperCase())
            .filter(Boolean)
        ),
      ];

      const formattedSeasons = [
        { value: "ALL", label: "Select All" },
        ...uniqueSeasons.map((season) => ({
          value: season,
          label: season,
        })),
      ];

      setSeasonOptions(formattedSeasons);
    }
  }, [styleListData, srtSeasonData]);
  useEffect(() => {
    if (styleListData?.length) {
      const allowedBrands = ["EDBR"];
      const filteredStyles = styleListData.filter((item) =>
        allowedBrands.includes(item?.brand)
      );
      const seasons = filteredStyles
        .map((item) => item?.season)
        .filter(Boolean);
      setSingleSeason([...new Set(seasons)]);

      const vendors = filteredStyles
        .flatMap((item) => {
          if (Array.isArray(item.factory)) return item.factory;
          if (item.factories) return item.factories.split(",");
          return [];
        })
        .map((vendor) => vendor.trim().toLowerCase())
        .filter(Boolean);

      const uniqueSortedVendors = [...new Set(vendors)]
        .map((v) => v.charAt(0).toUpperCase() + v.slice(1))
        .sort((a, b) => a.localeCompare(b));

      setSingleFactory(uniqueSortedVendors);

      const styleColors = filteredStyles
        .flatMap((item) =>
          item?.colors ? item.colors.split(",").map((c) => c.trim()) : []
        )
        .filter(Boolean).sort((a, b) => a.localeCompare(b));
      setSingleColor([...new Set(styleColors)]);

      const styleSizes = filteredStyles
        .flatMap((item) =>
          item?.sizes ? item.sizes.split(",").map((s) => s.trim()) : []
        )
        .filter(Boolean);
      setSingleSize([...new Set(styleSizes)]);
    }
  }, [styleListData]);

  const statusofsrt = useMemo(() => [
    { value: "", label: "-" },
    { value: "Hold", label: "Hold" },
    { value: "Approved", label: "Approved" },
    { value: "Override", label: "Override" },
    { value: "N/A", label: "N/A" },
    {
      value: teamFilter !== "BRAND" ? "Rejected" : "Dropped",
      label: teamFilter !== "BRAND" ? "Rejected" : "Dropped",
    },
  ],
    [teamFilter]
  );
  const [massFilterData, setMassFilterData] = useState(() => {
    const savedData = localStorage.getItem("massFilterData");
    return savedData
      ? { ...JSON.parse(savedData), brand: "EddieBauer" }
      : {
        searchFilter: null,
        brandFilter: "EddieBauer",
        colorFilter: "",
        sizeFilter: "",
        statusFilter: "",
        vendorFilter: "",
        seasonFilter: "",
        brand: "EddieBauer",
        sale_sample: 0,
      };
  });

  const srtMassFilterData = JSON.parse(localStorage.getItem("srtMassData"));
  console.log("massFilterData.seasonFilter", massFilterData.seasonFilter);
  useEffect(() => {
    if (hasInitialized.current) return;
    if (!location.pathname.includes("/sample-receipt-tracker/eddie-bauer")) {
      return;
    }
    hasInitialized.current = true;

    localStorage.setItem("srtActiveKey", "3");
    if (srtMassFilterData) {
      dispatch(
        massSearchFilter(
          srtMassFilterData?.searchFilter ? srtMassFilterData?.searchFilter : "",
          "EddieBauer",
          srtMassFilterData?.colorFilter ? srtMassFilterData?.colorFilter : "",
          srtMassFilterData?.sizeFilter ? srtMassFilterData?.sizeFilter : "",
          srtMassFilterData?.statusFilter ? srtMassFilterData?.statusFilter : "",
          srtMassFilterData?.vendorFilter ? srtMassFilterData?.vendorFilter : "",
          0,
          srtMassFilterData?.seasonFilter ? srtMassFilterData?.seasonFilter : "",
          current,
          pageCount
        )
      );
    } else if (massFilterData?.seasonFilter) {
      dispatch(
        getSrtInitialList(
          "EddieBauer",
          "",
          "",
          "",
          0,
          massFilterData?.seasonFilter,
          current || 1,
          pageCount
        )
      );
      setSeasonFilter(massFilterData?.seasonFilter);
    } else if (srtDataFromDashoard) {
      dispatch(
        getSrtInitialList(
          "EddieBauer",
          srtDataFromDashoard?.style ? srtDataFromDashoard?.style : "",
          srtDataFromDashoard?.factory ? srtDataFromDashoard?.factory : "",
          "",
          0,
          srtDataFromDashoard?.season ? srtDataFromDashoard?.season : "",
          current,
          pageCount
        )
      );
    } else if (srtDataForApi) {
      dispatch(
        getSrtInitialList(
          "EddieBauer",
          srtDataForApi?.style ? srtDataForApi?.style : "",
          srtDataForApi?.factory ? srtDataForApi?.factory : "",
          srtDataForApi?.rejected_date ? srtDataForApi?.rejected_date : "",
          0,
          srtDataForApi?.season ? srtDataForApi?.season : "",
          current,
          pageCount
        )
      );
    } else {
      dispatch(getSrtInitialList("EddieBauer", "", "", "", 0, "", 1, TOTAL_PER_PAGE));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("massFilterData", JSON.stringify(massFilterData));
  }, [massFilterData]);

  const onSearchChange = (e) => {
    setSearchFilter(e.target.value);
    localStorage.setItem(
      "srtData",
      JSON.stringify({
        brand: "EddieBauer",
        style: e.target.value,
        factory: vendorFilter ? vendorFilter : "",
        rejected_date: "",
        sale_sample: 0,
        season: seasonFilter ? seasonFilter : "",
      })
    );
  };

  const onStatusChange = (value) => {
    const finalValue = Array.isArray(value) ? value[0] : value;
    setStatusFilter(finalValue);
    setMassFilterData((prev) => ({ ...prev, statusFilter: finalValue }));
  };

  const onSeasonChange = (values) => {
    if (!values || values.length === 0) {
      handleSeasonClear();
      return;
    }

    const allSeasonValues = seasonOptions
      .filter((opt) => opt.value !== "ALL")
      .map((opt) => opt.value);

    const selectedValues = values.includes("ALL") ? allSeasonValues : values;

    setSeasonFilter(selectedValues);
    setCurrent(1);
    setPageCount(TOTAL_PER_PAGE);
    updateQueryParams(1, TOTAL_PER_PAGE);

    localStorage.removeItem("srtData");
    localStorage.removeItem("massFilterData");
    localStorage.setItem("srtMassData", JSON.stringify({
      searchFilter: "",
      brandfilter: "EddieBauer",
      colorFilter: "",
      sizeFilter: "",
      statusFilter: "",
      vendorFilter: "",
      sale_samplefilter: 0,
      seasonFilter: selectedValues,
    }));

    dispatch(resetMassFilter([]));
    dispatch(resetSrtSeasonFilter([]));
    dispatch(resetSrtData([]));
    dispatch(srtSeasonSearchFilter("EddieBauer", selectedValues, 1, TOTAL_PER_PAGE, 0));
    setMassFilterData((prev) => ({ ...prev, seasonFilter: selectedValues }));
  };

  const onFactoryChange = (value) => {
    setVendorFilter(value);
    setMassFilterData((prevData) => ({ ...prevData, vendorFilter: value }));
  };
  const onColorChange = (value) => {
    setColorFilter(value);
    setMassFilterData((prevData) => ({ ...prevData, colorFilter: value }));
  };

  const onSizeChange = (value) => {
    setSizeFilter(value);
    setMassFilterData((prevData) => ({ ...prevData, sizeFilter: value }));
  };

  const onSubmitClick = () => {
    setCurrent(1);
    setPageCount(TOTAL_PER_PAGE);
    updateQueryParams(1, TOTAL_PER_PAGE);
    localStorage.setItem(
      "srtMassData",
      JSON.stringify({
        searchFilter: searchFilter,
        brandfilter: "EddieBauer",
        colorFilter: colorFilter,
        sizeFilter: sizeFilter,
        statusFilter: statusFilter,
        vendorFilter: vendorFilter,
        sale_samplefilter: 0,
        seasonFilter: seasonFilter,
      })
    );
    dispatch(
      massSearchFilter(
        searchFilter ? searchFilter : "",
        "EddieBauer",
        colorFilter ? colorFilter : "",
        sizeFilter ? sizeFilter : "",
        statusFilter ? statusFilter : "",
        vendorFilter ? vendorFilter : "",
        0,
        seasonFilter ? seasonFilter : "",
        1,
        TOTAL_PER_PAGE
      )
    );
  };
  const exportToExcelEddie = () => {
    const selectedExportKeys = JSON.parse(localStorage.getItem("srtSelectedExportKeys")) || [];
    if (selectedExportKeys.length === 0) {
      toast.error("Please select at least one line item");
      return;
    }
    dispatch(
      srtExport({
        style: searchFilter ?? "",
        factory: vendorFilter ?? "",
        style_pids: selectedExportKeys,
        sale_sample: "0",
      })
    );
    dispatch(selectUnselectSrtTableRows([]));
  };
  const onRefresh = () => {
    localStorage.removeItem("srtMassData");
    localStorage.removeItem("massFilterData");
    localStorage.removeItem("DashboardData");
    localStorage.setItem(
      "srtData",
      JSON.stringify({
        brand: "EddieBauer",
        style: "",
        factory: "",
        rejected_date: "",
        sale_sample: 0,
      })
    );
    dispatch(
      getSrtInitialList(
        srtDataForApi?.brand ? srtDataForApi?.brand : "EddieBauer",
        srtDataForApi?.style ? srtDataForApi?.style : "",
        srtDataForApi?.factory ? srtDataForApi?.factory : "",
        srtDataForApi?.rejected_date ? srtDataForApi?.rejected_date : "",
        0,
        srtDataForApi?.season ? srtDataForApi?.season : "",
        1,
        TOTAL_PER_PAGE
      )
    );
    dispatch(resetSeasonFilter([]));
    dispatch(resetMassFilter([]));
    dispatch(selectUnselectSrtTableRows([]));
    resetExpandRef.current?.();
    setSearchFilter();
    setColorFilter();
    setSizeFilter();
    setStatusFilter();
    setVendorFilter();
    setSeasonFilter();
    setCurrent(1);
    setPageCount(TOTAL_PER_PAGE);
    updateQueryParams(1, TOTAL_PER_PAGE);
    handleSeasonClear();
  };
  const onSearchEnter = (event) => {
    if (event.key === "Enter") {
      const value = event.target.value;

      if (!value?.trim()) {
        toast.error("Please Enter Details");
        return;
      }

      setSearchFilter(value);

      setCurrent(1);
      setPageCount(TOTAL_PER_PAGE);
      updateQueryParams(1, TOTAL_PER_PAGE);

      localStorage.setItem(
        "srtMassData",
        JSON.stringify({
          searchFilter: value,
          brandfilter: "EddieBauer",
          colorFilter: "",
          sizefilter: "",
          statusFilter: "",
          vendorFilter: "",
          sale_samplefilter: 0,
          seasonFilter: seasonFilter ? seasonFilter : "",
        })
      );

      dispatch(
        massSearchFilter(
          value,
          "EddieBauer",
          "",
          "",
          "",
          "",
          0,
          seasonFilter ? seasonFilter : "",
          1,
          TOTAL_PER_PAGE
        )
      );
    }
  };

  const onSrtBulkUpload = (e) => {
    let formData = new FormData();
    formData.append("files", e.target.files[0]);
    formData.append("sale_sample", "0");
    formData.append("user", userNameMicrosoft);
    dispatch(srtBulkSave(formData, brandNameFromApi));
    e.target.value = null;
    formData = new FormData();
  };

  const handleSeasonClear = () => {
    setSeasonFilter();
    setMassFilterData((prev) => ({ ...prev, seasonFilter: "" }));

    localStorage.removeItem("srtMassData");
    localStorage.removeItem("massFilterData");
    localStorage.removeItem("srtData");

    dispatch(resetMassFilter([]));
    dispatch(resetSrtSeasonFilter([]));
    dispatch(resetSrtData([]));

    setCurrent(1);
    setPageCount(TOTAL_PER_PAGE);
    updateQueryParams(1, TOTAL_PER_PAGE);

    dispatch(getSrtInitialList("EddieBauer", "", "", "", 0, "", 1, TOTAL_PER_PAGE));
  };

  return (
    <div className="dickies-main-container">
      <div className="dickies-first-two-dropdowns">
        <div className="dickies-drop-down-one">
          <DropDown
            mode="multiple"
            allowClear
            onChange={onSeasonChange}
            onClear={handleSeasonClear}
            placeholder={"Season"}
            option={seasonOptions}
            value={seasonFilter}
            enableSelectAll
          />
        </div>
        <h2>EDDIE BAUER</h2>
        <div className="dickies-drop-down-two">
          <Button icon={<DownloadOutlined />} onClick={exportToExcelEddie}>
            Export
          </Button>
        </div>
      </div>

      {/* search dropdown button */}
      <div className="search-dropdown-button">
        <div className="dickies-search-input">
          <SearchInput
            onKeyPress={onSearchEnter}
            onChange={onSearchChange}
            value={searchFilter}
            placeholder={"Search by Parent Style"}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^a-zA-Z0-9," ]/g, "");
            }}
          />
        </div>
        <div className="dropdown-width dickies-drop-down-five">
          <Select
            allowClear
            placeholder={"Vendor"}
            data={singleFactory}
            value={vendorFilter}
            onChange={onFactoryChange}
          />
        </div>
        <div className="dropdown-width dickies-drop-down-five">
          <Select
            allowClear
            placeholder={"Color"}
            data={singleColor}
            value={colorFilter}
            onChange={onColorChange}
          />
        </div>
        <div className="dropdown-width dickies-drop-down-five">
          <Select
            allowClear
            placeholder={"Size"}
            data={singleSize}
            value={sizeFilter}
            onChange={onSizeChange}
          />
        </div>
        <div className="dropdown-width dickies-drop-down-five">
          <DropDown
            allowClear
            onChange={onStatusChange}
            placeholder={"Status"}
            option={statusofsrt}
            value={statusFilter}
          />
        </div>
        <div className="sync-icon">
          <SyncOutlined spin={srtRefresh} onClick={onRefresh} />
        </div>
        <div>
          <Button
            onClick={onSubmitClick}
            className="dickies-button"
            children={"SUBMIT"}
          />
        </div>

        <div>
          <Button
            className="dickies-button"
            onClick={() => fileRef.current.click()}
          >
            Bulk Update
          </Button>
          <input
            type="file"
            onChange={onSrtBulkUpload}
            accept="image/jpeg/png/jpg , application/pdf,.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            ref={fileRef}
            hidden
          />
        </div>
      </div>
      <div className="srt-table-container eddie-brand">
        <SrtTable
          selectedRows={selectedRows}
          onSelectionChange={setSelectedRows}
          data={massFilterData}
          brand={"EddieBauer"}
          current={current}
          pageCount={pageCount}
          setCurrent={setCurrent}
          setPageCount={setPageCount}
          totalPerPage={TOTAL_PER_PAGE}
          chunkSize={CHUNK_SIZE}
          containerRef={containerRef}
          resetExpandRef={resetExpandRef}
        />
      </div>
    </div>
  );
};

export default Eddie;